'use strict';

var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');

var onPromoCloseTracked = function() {

	appDom.iframe.remove();

};

var onPromoClick = function(e) {

	var $target = $(e.target);

	if ($target.hasClass('js-close-promo')) {

		appDom.iframe.css('display', 'none');

		triggerCustomEvent('promo-closed', {
			target: appDom.promo
		});

		appDom.promo.on('promo-close-tracked', onPromoCloseTracked);

	}

};

var init = function() {

	appDom.promo.on('click', onPromoClick);

};

module.exports = {
	init: init
};
